import { createRouter, createWebHistory } from 'vue-router'
import { getInstance } from '../auth';
import store from '../store'

// Import des composants (inchangé)
import Home from '../views/Home'
import MyProfile from '../views/MyProfile'
import MyData from '../views/MyData'
import BasicInfos from '../views/BasicInfos'
import MyConsumptions from '../views/MyConsumptions'
import MyPods from '../views/MyPods'
import MyAddresses from '../views/MyAddresses'
import MyIndexes from '../views/MyIndexes'
import MyEvents from '../views/MyEvents'
import AdminPage from '../views/admin/AdminPage'
import AdminUsers from '../views/admin/AdminUsers'
import AdminPodRequests from '../views/admin/AdminPodRequests'
import AdminEOC from '../views/admin/AdminEOC.vue'
import Faq from '../views/Faq'
import GDPR from '../views/gdpr.vue'
import LegalNotice from '../views/LegalNotice.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/profile',
    name: 'MyProfile',
    component: MyProfile,
    children: [
      { path: 'infos', name: 'infos', component: BasicInfos },
      { path: 'addresses', name: 'addresses', component: MyAddresses },
      { path: 'pods', name: 'pods', component: MyPods },
      { path: 'consumptions', name: 'consumptions', component: MyConsumptions },
      { path: 'indexes', name: 'indexes', component: MyIndexes },
      { path: 'events', name: 'events', component: MyEvents },
    ]
  },
  {
    path: '/admin',
    name: 'Administration',
    component: AdminPage,
    children: [
      { path: 'users', name: 'users', component: AdminUsers },
      { path: 'hpRequests', name: 'hpRequests', component: AdminPodRequests },
      { path: 'eoc', name: 'AdminEOC', component: AdminEOC }
    ]
  },
  { path: '/faq', name: 'faq', component: Faq },
  { path: '/gdpr', name: 'gdpr', component: GDPR },
  { path: '/legal-notice', name: 'legal-notice', component: LegalNotice },
  { path: '/data', name: 'MyData', component: MyData },
  { path: '/:catchAll(.*)', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.getElementById('app')?.scrollIntoView()
  }
})

// Navigation Guard
router.beforeEach((to, from, next) => {
  document.title = `MyConso - ${to.name}`
  const publicPages = ["/", "/faq", "/gdpr", "/legal-notice"]
  const authRequired = !publicPages.includes(to.path)
  const token = localStorage.getItem("auth_token")
  const isAuthenticated = getInstance().isAuthenticated

  if (authRequired && (!token || !isAuthenticated)) {
    return next({ path: "/", query: { redirectError: true, source: to.path }})
  }

  const userIsAdmin = store.getters['account/userIsAdmin']
  if (to.path.includes("/admin") && !userIsAdmin) {
    return next({ path: "/" })
  }

  const emailVerified = store.getters['account/isEmailVerified']
  if (to.path !== '/' && !emailVerified) {
    // optionnel : next({ path: "/" })
  }

  next()
})

router.afterEach(() => {
  store.dispatch("alert/clear", { root: true })
})

export default router
